var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.46745 6.28318L7.46745 11.2832C7.53713 11.3531 7.61992 11.4086 7.71109 11.4464C7.80225 11.4843 7.89999 11.5038 7.9987 11.5038C8.09741 11.5038 8.19515 11.4843 8.28631 11.4464C8.37748 11.4086 8.46027 11.3531 8.52995 11.2832L13.5299 6.28318C13.6708 6.14228 13.75 5.95118 13.75 5.75193C13.75 5.55267 13.6708 5.36157 13.5299 5.22068C13.3891 5.07978 13.198 5.00063 12.9987 5.00063C12.7994 5.00063 12.6083 5.07978 12.4674 5.22068L7.99807 9.69005L3.5287 5.22005C3.3878 5.07916 3.19671 5 2.99745 5C2.79819 5 2.60709 5.07916 2.4662 5.22005C2.3253 5.36095 2.24615 5.55204 2.24615 5.7513C2.24615 5.95056 2.3253 6.14166 2.4662 6.28255L2.46745 6.28318Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownMini);
export default __webpack_public_path__ + "static/media/arrowDownMini.89d5a2b543aaf01e2b25b6ef068c8d54.svg";
export { ForwardRef as ReactComponent };